export const initTextSection = [

    {
        "id" : "text1",
        "type": "text-element",
        "class": "text-element drag-element",
        "style": {
            "font-size": "45px",
            "font-style": "italic",
            "font-weight": "bold",
            "font-family":"Arial",
            "color": "black",
            "text-align": "center",
            "text-decoration" : "none",
            "transform":"translate(0px, 0px)"
        },
        "x": 0,
        "y": 0,
        "text": 'Aventure'
    },
    {
        "id" : "text2",
        "type": "text-element",
        "class": "text-element drag-element",
        "style": {
            "font-size": "45px",
            "font-style": "italic",
            "font-weight": "bold",
            "font-family":"Arial",
            "color": "black",
            "text-align": "center",
            "text-decoration" : "none",
            "transform":"translate(0px, 0px)"
        },
        "x": 0,
        "y": 0,
        "text": 'Aventure <br> excep'
    },
    {
        "id" : "text3",
        "type": "text-element",
        "class": "text-element drag-element",
        "style": {
            "font-size": "45px",
            "font-style": "italic",
            "font-weight": "bold",
            "font-family":"Arial",
            "color": "black",
            "text-align": "center",
            "text-decoration" : "none",
            "transform":"translate(0px, 0px)"
        },
        "x": 0,
        "y": 0,
        "text": 'Date'
    },
    {
        "id" : "text4",
        "type": "text-element",
        "class": "text-element drag-element",
        "style": {
            "font-size": "45px",
            "font-style": "italic",
            "font-weight": "bold",
            "font-family":"Arial",
            "color": "black",
            "text-align": "center",
            "text-decoration" : "none",
            "transform":"translate(0px, 0px)"
        },
        "x": 0,
        "y": 0,
        "text": 'Classement'
    },
    {
        "id" : "text5",
        "type": "text-element",
        "class": "text-element drag-element",
        "style": {
            "font-size": "45px",
            "font-style": "italic",
            "font-weight": "bold",
            "font-family":"Arial",
            "color": "black",
            "text-align": "center",
            "text-decoration" : "none",
            "transform":"translate(0px, 0px)"
        },
        "x": 0,
        "y": 0,
        "text": 'Distance'
    },
    {
        "id" : "text6",
        "type": "text-element",
        "class": "text-element drag-element",
        "style": {
            "font-size": "45px",
            "font-style": "italic",
            "font-weight": "bold",
            "font-family":"Arial",
            "color": "black",
            "text-align": "center",
            "text-decoration" : "none",
            "transform":"translate(0px, 0px)"
        },
        "x": 0,
        "y": 0,
        "text": 'Temps'
    },
    {
        "id" : "text7",
        "type": "text-element",
        "class": "text-element drag-element",
        "style": {
            "font-size": "45px",
            "font-style": "italic",
            "font-weight": "bold",
            "font-family":"Arial",
            "color": "black",
            "text-align": "center",
            "text-decoration" : "none",
            "transform":"translate(0px, 0px)"
        },
        "x": 0,
        "y": 0,
        "text": '#Dossard'
    },


]